import { motion } from "framer-motion";
import React from "react";
import { adds } from "../../../assets";
import Button from "../../../components/Button";
import "./index.css";

const Ingresos = ({ variants }) => {
  return (
    <div className="ingresos section relative">
      <img className="blur blur1" src={adds.blur1} alt="Blur" />

      <div className="container-lg flex flexCol alignCenter textCenter">
        <motion.h5
          variants={variants}
          initial={"initial"}
          whileInView={"ani"}
          viewport={{ once: true }}
          custom={0.3}
        >
          Services
        </motion.h5>
        <motion.h2
          variants={variants}
          initial={"initial"}
          whileInView={"ani"}
          viewport={{ once: true }}
          custom={0.6}
        >
          Drive your business
        </motion.h2>
        <motion.p
          variants={variants}
          initial={"initial"}
          whileInView={"ani"}
          viewport={{ once: true }}
          custom={0.9}
          className="parDes"
        >
          Apply Big Data or Data Science to create automated systems that
          maximize your revenue, or choose the service that best fits your
          needs.
        </motion.p>
        <Button
          color={"white"}
          text={"View services"}
          href={"/servicios"}
          type={"link"}
          variants={variants}
          delay={1.2}
        />
      </div>
    </div>
  );
};

export default Ingresos;
